import { QueueIdEnum } from 'src/app/care/inbox/shared/enums';

/**
 * The angularjs states related to the module pushbox
 */
pushboxStates.$inject = ['$stateProvider'];
export function pushboxStates($stateProvider) {
  $stateProvider
    .state('auth.alcmeon.pushbox', {
      url: '/pushbox',
      resolve: {
        taskListConfiguration: [
          'AngularPushboxService',
          'initFromSelf',
          function (AngularPushboxService) {
            // initFromSelf injection above is necessary to wait for the result of /self
            AngularPushboxService.updateAvailableTaskListConfigs();
            return AngularPushboxService.getTaskListConfiguration();
          },
        ],
      },
      views: {
        'sub-nav@auth': {
          controller: [
            '$scope',
            'taskListConfiguration',
            function ($scope, taskListConfiguration) {
              $scope.taskListConfiguration = taskListConfiguration;
            },
          ],
          template: `<angular-pushbox-left-navigation
            [task-list-configuration]="taskListConfiguration"
            class="minimal-scrollbar"></angular-pushbox-left-navigation>`,
        },
        'container@auth': {
          controller: 'PushboxNgController',
          template: require('src/ajs-app/components/tasks/pushbox/pushbox-ng/pushbox-ng.html'),
        },
      },
    })

    .state('auth.alcmeon.pushbox.tasks', {
      url: '/assigned-to-you',
      params: {
        queueId: { squash: true },
      },
      resolve: {
        isUserPushMode: [
          '$state',
          '$stateParams',
          '$q',
          'loggedUser',
          'initFromSelf',
          function ($state, $stateParams, $q, loggedUser) {
            if (!loggedUser.is_in_push_mode) {
              // The user is not in push mode, redirects the user to an inbox task list page.
              $state.go('auth.alcmeon.inbox.list.tasks', {
                companyId: $stateParams.companyId,
                queueId: QueueIdEnum.AssignedToYou,
              });

              return $q.reject();
            }
            return $q.resolve(true);
          },
        ],
      },
      views: {
        task: {
          template:
            '<angular-pushbox-task-list [task-list-configuration]="taskListConfiguration"></angular-pushbox-task-list>',
        },
      },
    })

    .state('auth.alcmeon.pushbox.process', {
      url: '/task/{processedTaskId:int}?acquire&hide-nav',

      // Contrary to the .process state for "traditional" inbox,
      // in push mode the task acquisition is in general handled by the PushboxController
      // (because it needs to retry if someone else has acquired the task, and display an error message in case of failure)
      // Hence we don't use the 'addTaskStates()' method to add the '.process' substate: we declare it here.
      // Note that we still need to handle the special case where the user clicked on the yellow button to process a newer message;
      // in that case we do need to try to acquire the task here,
      // but we do not allow the transition if it was acquired faster by another user
      resolve: {
        isUserPushMode: [
          '$state',
          '$stateParams',
          '$q',
          'loggedUser',
          'initFromSelf',
          function ($state, $stateParams, $q, loggedUser) {
            if (!loggedUser.is_in_push_mode) {
              // The user is not in push mode, redirects the user to an inbox task page.
              $state.go('auth.alcmeon.inbox.list.tasks.process', {
                companyId: $stateParams.companyId,
                processedTaskId: $stateParams.processedTaskId,
              });
              return $q.reject();
            }
            return $q.resolve(true);
          },
        ],
        acquire: [
          'loggedUser',
          '$q',
          '$state',
          '$stateParams',
          'AngularTaskActionsService',
          'AlertingFactory',
          'AngularPushboxService',
          'isUserPushMode',
          'taskListConfiguration',
          'AngularCountersService',
          async function (
            loggedUser,
            $q,
            $state,
            $stateParams,
            AngularTaskActionsService,
            AlertingFactory,
            AngularPushboxService,
            isUserPushMode,
            taskListConfiguration,
            AngularCountersService
          ) {
            if (!isUserPushMode) {
              // Prevent the user to continue if he is not in push mode.
              return $q.reject();
            }

            let counters = await AngularCountersService.getCounters([taskListConfiguration]).toPromise();
            const assignedTasksIds = counters[0].taskIds || [];

            if (!assignedTasksIds.includes($stateParams.processedTaskId)) {
              // If no new tasks redirects to the pushbox
              // Free's advisors become too smart, add a guard to redirect to the highest priority task if the user tries to change the url.
              // Redirects to the pushbox and let the user triggers the mecanism to get the highest priority task.
              AngularPushboxService.getHighestPriorityTask().subscribe(response => {
                if ((response.status === 204 && !response.body) || response.body.id !== $stateParams.processedTaskId) {
                  AlertingFactory.info('pushbox/forbidden-redirect');
                  $state.go('auth.alcmeon.pushbox', { companyId: $stateParams.companyId });
                  return $q.reject();
                }
              });
            }

            if ($stateParams.acquire) {
              AngularTaskActionsService.assign($stateParams.processedTaskId, $stateParams.acquire).subscribe(
                response => {
                  if (!AngularTaskActionsService.wasAcquiredByMe(response, $stateParams.processedTaskId, loggedUser)) {
                    AlertingFactory.error('pushbox/error/acquisition-max-retry');
                    $state.go('auth.alcmeon.pushbox');
                    return $q.reject();
                  }
                  // else the then() promise will be resolved with no value,
                  // but the 'acquire' resolve isn't used in the controller anyway
                }
              );
            }
            // else the resolve method doesn't return anything,
            // but the 'acquire' resolve isn't used in the controller anyway
          },
        ],
      },
      views: {
        task: {
          controller: 'TaskProcessWrapperController',
          template: require('src/ajs-app/components/tasks/task-process-wrapper/task-process-wrapper.html'),
        },
      },
    });
}
